module.exports = __webpack_public_path__ + "static/media/tetris-bg3.4618a5b4.webp";